import React from 'react';
export function HeroSection() {
  return <section className="space-y-6 text-lg leading-relaxed text-stone-800" data-id="element-17">
      <h1 className="text-3xl sm:text-4xl md:text-[2.75rem] font-bold text-stone-900 leading-[1.2] mb-4 font-serif" data-id="element-18">
        Something Incredible Is Happening To Teeth In Glendale, California — And
        It Started Quietly In One Armenian Dentist's Office…
      </h1>

      <img src="https://cdn.magicpatterns.com/uploads/u1Q416ScBRmrFQRssxSRFY/Slice_9_(2)_(1).png" alt="Glendale dentist office, mineral crystals, and microscopic enamel imagery" className="w-full rounded-md" data-id="element-19" />

      <div className="bg-yellow-50 border border-yellow-200 rounded-md px-5 py-4 mb-4" data-id="element-20">
        <p className="italic text-stone-700 text-lg leading-relaxed" data-id="element-21">
          In This Exclusive 3-Minute Interview, The 35-Year Armenian Dentist
          Behind The Viral 'Mineral Candy' Reveals How It Rebuilds Enamel &
          Restores Gum Health At Both The Biological and Structural Level
        </p>
      </div>

      <p data-id="element-22">
        After 35+ years of watching countless patients end up in his chair
        despite doing everything right, an Armenian dentist from Glendale, Los
        Angeles developed a simple two-step “Clear and Guard” protocol which
        combines 6 breakthrough compounds shown in 60+ clinical studies to
        reduce new cavity development by 450%, cut gum inflammation by 40%, and
        outperform prescription-strength antibacterial rinses — without killing
        a single healthy bacterium in the process.
      </p>

      <p data-id="element-23">But what’s making dentists even more suspicious is this…</p>

      <p data-id="element-24">
        What started quietly in his own office is now causing waves throughout
        the tight-knit Armenian community in Glendale…
      </p>

      <p data-id="element-25">
        As people who spent years covering their mouths when they laughed are
        finally waking up with fresh breath, smooth teeth, and gums that no
        longer bleed when they brush.
      </p>

      <p data-id="element-26">
        The suspicious part? None of them changed a single thing about their
        existing routine…
      </p>

      <p data-id="element-27">
        Instead, all they did was dissolve a “mineral candy” in their mouth
        after they brush in the morning….
      </p>

      <p data-id="element-28">
        And now, for the first time ever, what is now known as “ClearGuard Pro”
        is being made available online to the lucky few who are able to get
        their hands on this extremely limited batch.
      </p>

      <p data-id="element-29">
        Using 100% naturally derived ingredients, ClearGuard Pro works in two
        simultaneous steps — first smoothing the enamel surface so bacteria
        physically cannot grip it, then recolonizing the mouth with the exact
        strains that crowd out the bacteria causing decay and gum disease.
      </p>

      <p data-id="element-30">
        And since it’s formulated as a slowly dissolving chew that ensures
        enough contact time with teeth, the result is a mouth that defends
        itself — the way it was always supposed to.
      </p>

      <p data-id="element-31">
        At the core of the protocol is microcrystalline hydroxyapatite — the
        exact mineral human tooth enamel is made of — which bonds directly to
        the enamel surface, filling the microscopic cracks harmful bacteria use
        as anchor points, while simultaneously acting as a sacrificial mineral
        layer that absorbs acid attacks before they reach your real teeth.
      </p>

      <div className="pt-8 pb-4" data-id="element-32">
        <h2 className="text-2xl sm:text-3xl font-bold text-stone-900 text-center italic font-serif" data-id="element-33">
          Exclusive interview with the creator of ClearGuard Pro, Dr. Avedis
          Tevanian DDS
        </h2>
      </div>
    </section>;
}